// extracted by mini-css-extract-plugin
var _1 = "SearchListHeader-moduleSearchListHeader__TfK93 SearchSectionHeader-moduleSearchSectionHeader__c9B21";
export { _1 as "SearchListHeader" }
